module.exports = __webpack_public_path__ + "static/img/des8-bg.df5e7ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/des8-bg.jpg
// module id = lyXF
// module chunks = 0